import Web3 from 'web3'

export const providers = {
    readProvider: Web3.givenProvider,
    writeProvider: Web3.givenProvider
}